import { render, staticRenderFns } from "./TokenCooldownTimeBucketPicker.vue?vue&type=template&id=5bcd34a4&scoped=true"
import script from "./TokenCooldownTimeBucketPicker.vue?vue&type=script&lang=ts"
export * from "./TokenCooldownTimeBucketPicker.vue?vue&type=script&lang=ts"
import style0 from "./TokenCooldownTimeBucketPicker.vue?vue&type=style&index=0&id=5bcd34a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd34a4",
  null
  
)

export default component.exports